import { partnersDomain, payerDomain as aggregatorsDomain } from '../../Common/constants';

export const agenciesUrl = `${partnersDomain}/agency/`;

export const partnersUrl = `${partnersDomain}/partner/`;

export const aggregatorsUrl = `${aggregatorsDomain}/aggregators/`;
